import { useEffect } from "react";

/*
 * Loads Google Fonts that only some pages use (the old pages), when that page
 * opens, instead of on every visit. The site's own fonts are in
 * public/index.html.
 *   useGoogleFonts("Rubik+Dirt&family=Fjalla+One")  // the part after family=
 */
export function useGoogleFonts(families) {
  useEffect(() => {
    const href = `https://fonts.googleapis.com/css2?family=${families}&display=swap`;
    if (document.querySelector(`link[href="${href}"]`)) return;
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    document.head.appendChild(link);
  }, [families]);
}

// The old pages' fonts
export const LEGACY_MUSIC_FONTS =
  "Fjalla+One&family=Rubik+Glitch&family=Rubik+Dirt&family=Rubik+Doodle+Shadow";
export const DINNER_MENU_FONTS =
  "Great+Vibes&family=Dancing+Script:wght@400;500;600;700&family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400;1,500;1,600;1,700&family=Parisienne&family=Kaisei+HarunoUmi";
